/* angular:styles/component:css;8fe27d1b84c4c60f0ea0f1f1a3d05b02e3ebb1304be42853cd97eeabd44e689d;/app/src/app/shared/animations/drop-down-list.ts */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
input[type=number] {
  -moz-appearance: textfield;
}
.disable-selection {
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
.search-box-wrapper {
  margin-top: -8px;
  position: absolute;
  width: 100%;
}
.additional-charges-form {
  background-color: #ffffff;
  width: 100%;
  height: 36px;
  border-radius: 8px;
  padding-inline-start: 8px;
  padding-top: 8px;
  font-family: Lato;
  font-size: 13px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #333333;
  border: solid 1px #c8c7cc;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  padding-right: 24px;
}
.additional-charges-clickable {
  cursor: pointer;
}
.additional-charges-div {
  position: relative;
  width: 100%;
}
.additional-charges-img {
  position: absolute;
  left: 52px;
  top: 8px;
}
.code-changeable-img {
  position: absolute;
  right: 16px;
  top: 16px;
}
.spacer {
  padding-bottom: 4px;
}
/*# sourceMappingURL=drop-down-list.css.map */
